// extracted by mini-css-extract-plugin
export var errorsContainer = "_r9-1";
export var link = "_r9-0";